
import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from '@mui/material/Paper';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { TableContainerWrapper, TableBox } from './TableStyled';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import Pagination from '@mui/material/Pagination';
import { Content } from './Content';
import moment from 'moment';
import { TabContext } from '@mui/lab';
import CompareQuotesReducer from '../../../Reducers/CompareQuotesReducer';
import { useDispatch } from 'react-redux';
import { ADD_QUOTES_TO_COMPARE } from '../../../ActionTypes/ActionTypes';

const ActionTabTable = ({ rows, customActions, headerCells, statusColors, searchText, pageNumber, handleChangePage, quotesLoading }) => {
    const formattedRows = rows.map((row) => {
        const item = { ...row };

        item.createdDate = moment(item.createdDate).format('MM-DD-YYYY');
        item.totalHeadCount = item.totalHeadCount?.toLocaleString();
        item.utilization = parseFloat(item.utilization || 0).toFixed(2);
        item.sessions = parseFloat(item.sessions || 0).toFixed(2);
        item.commission = parseFloat(item.commission || 0).toFixed(2);

        const lastapprovar = item?.approverDetails?.split('|') || [];
        item.approverDetails = `${lastapprovar[0] ? lastapprovar[0] : ''} ${lastapprovar[1] ? lastapprovar[1] : ''}`;
        item.samLeadershipTeamApprovalDate = `${lastapprovar[3] ? moment(lastapprovar[3].slice(0, -1)).format('MM-DD-YYYY') : ''}`;

        const pricingapprovar = item?.pricingApproverDetails?.split('|') || [];
        item.pricingTeamApprover = `${pricingapprovar[0] ? pricingapprovar[0] : ''} ${pricingapprovar[1] ? pricingapprovar[1] : ''}`;
        item.pricingTeamApprovalDate = `${pricingapprovar[3] ? moment(pricingapprovar[3].slice(0, -1)).format('MM-DD-YYYY') : ''}`;

        const pricingManagerApprover = item?.pricingManagerApproverDetails?.split('|') || [];
        item.pricingManagerApproverDetails = `${pricingManagerApprover[0] ? pricingManagerApprover[0] : ''} ${pricingManagerApprover[1] ? pricingManagerApprover[1] : ''}`;
        item.pricingManagerApprovalDate = `${pricingManagerApprover[3] ? moment(pricingManagerApprover[3].slice(0, -1)).format('MM-DD-YYYY') : ''}`;

        const pricingVPApprover = item?.pricingVPApproverDetails?.split('|') || [];
        item.pricingVPapproverDetails = `${pricingVPApprover[0] ? pricingVPApprover[0] : ''} ${pricingVPApprover[1] ? pricingVPApprover[1] : ''}`;
        item.pricingVPApprovalDate = `${pricingVPApprover[3] ? moment(pricingVPApprover[3].slice(0, -1)).format('MM-DD-YYYY') : ''}`;

        return item;
    });
    
     const dispatch = useDispatch();
    
    const [rowsPerPage, setRowsPerPage] = useState(12);
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = useState("");
    const [isDate, setIsDate] = useState(false);
    const tableRows = searchText === '' ? [...formattedRows] :
        formattedRows.filter(x => x.quoteName?.toLowerCase().includes(searchText.toLowerCase())
            || x.accountName?.toLowerCase().includes(searchText.toLowerCase())
            || x.oppurtunity?.toLowerCase().includes(searchText.toLowerCase())
            || x.oppurtunityName?.toLowerCase().includes(searchText.toLowerCase())
            || x.createdDate?.toLowerCase().includes(searchText.toLowerCase())
            || x.statusName?.toLowerCase().includes(searchText.toLowerCase())
            || x.currencyCode?.toLowerCase().includes(searchText.toLowerCase())
            || x.totalHeadCount?.toString().toLowerCase().includes(searchText.toLowerCase())
            || x.pricingStructureName?.toLowerCase().includes(searchText.toLowerCase())
            || x.blendedRateReqCurrency?.toString().toLowerCase().includes(searchText.toLowerCase())
            || x.utilization?.toString().toLowerCase().includes(searchText.toLowerCase())
            || x.sessions?.toString().toLowerCase().includes(searchText.toLowerCase())
            || x.hours?.toString().toLowerCase().includes(searchText.toLowerCase())
            || x.totalAnnualRevenue?.toString().toLowerCase().includes(searchText.toLowerCase())
            || x.brokerName?.toLowerCase().includes(searchText.toLowerCase())
            || x.commission?.toString().toLowerCase().includes(searchText.toLowerCase())
            || x.productName?.toLowerCase().includes(searchText.toLowerCase())
            || x.productVariationName?.toLowerCase().includes(searchText.toLowerCase()));
              

    useEffect(() => {
        setOrderBy("");
      }, [rows]);
    const createSortHandler = (property,isDate) => (event) => {
        setOrder(order == 'asc' ? 'desc' : 'asc');
        setOrderBy(property);
        setIsDate(isDate);
    };
    function descendingComparator(a, b, orderBy) {
        if(orderBy!="")
        {
        if (!b[orderBy] ) return -1;
        if(!a[orderBy] ) return 1;
       if(isDate)
       { if (new Date(b[orderBy]) < new Date(a[orderBy])) {
            return -1;
        }
        if (new Date(b[orderBy]) > new Date(a[orderBy])) {
            return 1;
        }}
        else{
            if (b[orderBy] < a[orderBy]) {
                return -1;
            }
            if (b[orderBy] > a[orderBy]) {
                return 1;
            }
        }}
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) {
                return order;
            }
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }

    function getFormattedData(header, row) {                
        return (header === 'blendedRateReqCurrency' || header === 'totalAnnualRevenue') && (row[header] !== null) ?
            row['currencyCode'] + ' ' + row[header]?.toLocaleString("en", {
                useGrouping: true,
                roundingMode: "trunc",
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
            }): row[header];
    }
    
    return (
        <TableBox>
            <TableContainerWrapper component={Paper}>
                <Box className="tableContainer">
                    <Table stickyHeader aria-label="simple table"  >
                        <TableHead>
                            <TableRow >
                                <TableCell size='small'  className='fixedcolumnHeaderone'>{Content.ACTION}</TableCell>
                                {headerCells.map((headerCell) => (
                                    <TableCell size='small'
                                        className={headerCell.id === 'statusName' ? 'fixedcolumnHeadertwo' : 'dragColumnHeader'}
                                        key={headerCell.id}
                                        align={headerCell.align}
                                    >
                                        {headerCell.label}
                                        {<TableSortLabel
                                            active={orderBy === headerCell.id}
                                            direction={orderBy === headerCell.id ? order : 'desc'}
                                            onClick={createSortHandler(headerCell.id,headerCell?.isDate)}>
                                        </TableSortLabel>}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {tableRows.length > 0 ? (
                            (rowsPerPage > 0 ? stableSort(tableRows, getComparator(order, orderBy)).slice(
                                (Number(pageNumber) - 1) * rowsPerPage,
                                (Number(pageNumber) - 1) * rowsPerPage + rowsPerPage,) : tableRows)
                                    .map((row) => (
                                    
                                    <TableRow
                                        key={row.rowId}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >                                           
                                        <TableCell size='small'  className='fixedColumnone'>
                                            {customActions && customActions(row)}
                                        </TableCell>
                                        {headerCells.map((headerCell) => (
                                            <TableCell size='small'
                                                key={headerCell.id}
                                                align={headerCell.align}
                                                sx={{
                                                    color:
                                                        headerCell.id === 'statusName'
                                                            ? statusColors[row[headerCell.id]]
                                                            : 'inherit',
                                                    fontWeight: 600
                                                }}
                                                className={headerCell.id === 'statusName' ? statusColors[row[headerCell.id]]+' fixedColumntwo'  : 'dragColumn'}
                                            >
                                                {getFormattedData(headerCell.id, row) } 
                                                    
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))) : (
                                <TableRow className='noDataRow'>
                                        {!quotesLoading && tableRows.length ===0 &&
                                            <TableCell colSpan={headerCells.length + 1} align="center" className='noquotecell' >
                                                <p className='noquotetext'> Quotes are not available for the selected opportunity.
                                                    Click "<strong>Create Request</strong>" to create a new quote.</p>
                                            </TableCell>}
                                        {quotesLoading &&
                                            <TableCell colSpan={headerCells.length + 1} align="center" className='noquotecell' >
                                                <p className='noquotetext'> Fetching quotes.. Please wait</p>
                                            </TableCell>}

                                </TableRow>
                            )
                            }
                        </TableBody>
                    </Table>
                </Box>
            </TableContainerWrapper>
            <Box className='paginationContainer'>
                <Typography variant='h6'>{tableRows.length}<span>{Content.TOTAL_RESULT}</span></Typography>
                <Pagination
                sx={{
                    fontFamily: '"Noto Sans", sans-serif', 
                }}
                    count={Math.ceil(tableRows.length / rowsPerPage)}
                    page={pageNumber}
                    onChange={handleChangePage} // Use onChange for page changes
                // Use onRowsPerPageChange for rows per page changes
                />
            </Box>

        </TableBox>
    );
}

export default ActionTabTable;

